export default __webpack_public_path__ + "static/media/picture-browse-icon.c3057957.svg";